<template>
    <Benchmark />
</template>

<script>
import Benchmark from './components/Benchmark.vue';
    export default {
        components: {
            Benchmark
        }
    }
</script>

<style lang="scss">
@import "../styles/benchmark/benchmark.scss";

:root.dark #benchmark,
:root.dark #benchmark h1,
:root.dark #benchmark h2,
:root.dark #benchmark h3,
:root.dark #benchmark h4,
:root.dark #benchmark h5,
:root.dark #benchmark h6,
:root.dark #benchmark p,
:root.dark #benchmark span,
:root.dark #benchmark li,
:root.dark #benchmark td,
:root.dark #benchmark th,
:root.dark #benchmark label,
:root.dark #benchmark small,
:root.dark #benchmark strong,
:root.dark #benchmark em,
:root.dark #benchmark a,
:root.dark #benchmark button,
:root.dark #benchmark input,
:root.dark #benchmark select,
:root.dark #benchmark textarea {
    color: #111 !important;
}

:root.dark #benchmark ::placeholder {
    color: #333 !important;
}

[v-cloak] {
    display: none
}
</style>
